import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import classNames from 'classnames';
import * as AppState from '../../../../AppState';
import FilterDropdown from '../../../Shared/FilterDropdown/FilterDropdown';
import PriceRange from './PriceRange';
import formatCash from '../../../../utilities/formatCash';

import './PriceRangeButton.scss';

const PriceRangeButton = () => {
	const gsPriceRangeFilterApplied = useRecoilValue(AppState.gsPriceRangeFilterAppliedSelector);
	const [buttonLabel, setButtonLabel] = React.useState('Price');
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	// Apply filter values to label
	React.useEffect(() => {
		// If both filters, show both values
		if (gsFilters.priceMin !== 0 && gsFilters.priceMax !== -1) {
			setButtonLabel(`$${formatCash(gsFilters.priceMin)} - $${formatCash(gsFilters.priceMax)}`);
		} else if (gsFilters.priceMin !== 0 && gsFilters.priceMax === -1) {
			// If min but not max, show min
			setButtonLabel(`$${formatCash(gsFilters.priceMin)} Min.`);
		} else if (gsFilters.priceMin === 0 && gsFilters.priceMax !== -1) {
			// If max but not min, show max
			setButtonLabel(`$${formatCash(gsFilters.priceMax)} Max.`);
		} else setButtonLabel('Price');
	}, [gsPriceRangeFilterApplied, gsFilters.priceMin, gsFilters.priceMax]);

	return (
		<FilterDropdown
			id='hsPriceRangeFilterButton'
			label={buttonLabel}
			active={gsPriceRangeFilterApplied}
			className={classNames((gsPriceRangeFilterApplied ? 'cc-btn--secondary homesearch-filters__cc-btn--active' : 'cc-btn--gray'), 'cc-btn cc-btn--outline cc-btn--reset-text justify-content-center cc-btn--navbar homesearch-filters__cc-btn--price-range')}
			options={ <PriceRange /> }
			onResetClick={() => {
				setGsFilters(currVal => ({...currVal, priceMin: 0, priceMax: -1}));
			}}
		/>
	);
};

export default PriceRangeButton;
